import React, { useEffect, useState } from 'react'
import AXIOSCONFIGMETHOD from '../../../../components/apiCall/axiosConfig'
import { webServiceUrl } from '../../../../components/apiCall/webserviceurl'
import { SocialIcon } from 'react-social-icons/component'
import 'react-social-icons/facebook'
import 'react-social-icons/x'
import 'react-social-icons/instagram'
import 'react-social-icons/linkedin'
import 'react-social-icons/youtube'
import { ImSphere } from "react-icons/im";
import { FaFacebook } from "react-icons/fa6";

import 'react-social-icons/threads'
import Loading from '../../../../components/common/Loading'
function About_ihfc() {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    try {
      setLoading(true);
      const resp = await AXIOSCONFIGMETHOD("POST", webServiceUrl.about_ihfc)
      console.log(resp?.data?.text?.split("/n/p"));
      setData(resp?.data);
    } catch (error) {
      console.error("Failed to fetch data", error);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  useEffect(() => {
    getData()
  }, [])

  return (
    <div>
      {loading
        ? <div className="py-5" style={{ height: "20vh" }}><Loading /></div>
        : <>
          <section className="max-w-7xl mx-auto px-6 py-12">
            <p className="subHeading">
             About IHFC 
            </p>
            {/* {data?.text?.split("/n/p").map((paragraph, index) => (
              <h6 key={index} className="ihfc_text ">
                {paragraph.trim()}
              </h6>
            ))} */}

<div
  className="prose"
  dangerouslySetInnerHTML={{
    __html: data?.text ? data.text.trim() : "",
  }}
/>
{/* 
            <div
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(data?.text),
  }}
/> */}
          </section>
          <div className="ihfc_text flex gap-3 items-center my-5">
            <a href="https://www.facebook.com/ihfc.iitdelhi" target="_blank" rel="noopener noreferrer" style={{ marginRight: "4px" }}>
              <FaFacebook size={24} color='#0866ff' />
            </a>
            {/* <ImSphere url="https://www.facebook.com/ihfc.iitdelhi" target="_blank" style={{ height: 25, width: 25,marginRight:"4px" }} /> */}
            <SocialIcon url="https://x.com/ihfc_tih" target="_blank" style={{ height: 25, width: 25, marginRight: "4px" }} />
            <SocialIcon url="https://www.instagram.com/ihfc_tih/" target="_blank" style={{ height: 25, width: 25, marginRight: "4px" }} />
            <SocialIcon url="https://www.linkedin.com/company/ihfc/posts/" target="_blank" style={{ height: 25, width: 25, marginRight: "4px" }} />
            <SocialIcon url="https://www.youtube.com/channel/UCxOs-cVcM-m0o9thWigH6hQ" target="_blank" style={{ height: 25, width: 25, marginRight: "4px" }} />
            <SocialIcon url="https://www.threads.net/@ihfc_tih" target="_blank" style={{ height: 25, width: 25, marginRight: "4px" }} />
            <a href="https://www.ihfc.co.in" target="_blank" rel="noopener noreferrer">
              <ImSphere size={25} />
            </a>
          </div>
        </>
      }
    </div>
  );

}

export default About_ihfc
